import { IonIcon } from '@ionic/react'
import { chevronDown, chevronUp } from 'ionicons/icons'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
import NumberInput from '../../../../components/inputs/NumberInput'
import useUser from '../../../../contexts/hooks/useUser'
import { trpc } from '../../../../modules/trpc'

const SolarChargingButton: React.FC = () => {
	const { user } = useUser()

	const { t } = useTranslation('pages_electricCar', { keyPrefix: 'solarCharging' })

	const [isInfoOpen, setIsInfoOpen] = useState(false)

	const { data: userSettings, refetch } = trpc.user.userSettings.get.useQuery(undefined, {
		enabled: !!user?.id,
	})

	// Edit user settings mutation
	const { mutate: editUserSettings } = trpc.user.userSettings.edit.useMutation({
		onSuccess: () => {
			refetch()
		},
	})

	return (
		<>
			<div className='w-full flex flex-row gap-2 justify-center'>
				<Button onClick={() => setIsInfoOpen(!isInfoOpen)} className='m-0'>
					<div className='flex flex-row items-center justify-center gap-4'>
						<span className='text-center  text-text-dark dark:text-white'>{t('title')}</span>

						{isInfoOpen ? (
							<IonIcon icon={chevronUp} style={{ fontSize: '16px' }} />
						) : (
							<IonIcon icon={chevronDown} style={{ fontSize: '16px' }} />
						)}
						<span className='bg-highlight flex justify-center items-center text-white font-semibold px-4 py-2 rounded-full absolute left-3/4'>
							Beta
						</span>
					</div>
				</Button>
			</div>

			{isInfoOpen && (
				<div className='flex flex-col gap-2 text-center w-full'>
					<div className='flex flex-col gap-4 w-full'>
						<Button
							onClick={() =>
								editUserSettings({
									userId: user?.id ?? 0,
									data: {
										solarChargingEnabled: !userSettings?.solarChargingEnabled,
									},
								})
							}
							className='m-0 !w-fit mx-auto'
						>
							{userSettings?.solarChargingEnabled ? t('deactivate') : t('activate')}
						</Button>

						<div className='flex flex-col md:flex-row gap-2'>
							<div className='mb-2 rounded-xl bg-white dark:bg-[#0d2d30] border border-background-200-light dark:border-surface-dark p-4'>
								<NumberInput
									label={`${t('turnOnThreshold')} (kW)`}
									value={userSettings?.solarChargingTurnonThreshold?.toString() || ''}
									onChange={value =>
										editUserSettings({
											userId: user?.id ?? 0,
											data: {
												solarChargingTurnonThreshold: parseFloat(value || '0'),
											},
										})
									}
									helperText={t('turnOnThresholdHelp')}
								/>
							</div>

							<div className='mb-2 rounded-xl bg-white dark:bg-[#0d2d30] border border-background-200-light dark:border-surface-dark p-4'>
								<NumberInput
									label={`${t('turnOffThreshold')} (kW)`}
									value={userSettings?.solarChargingTurnoffThreshold?.toString() || ''}
									onChange={value =>
										editUserSettings({
											userId: user?.id ?? 0,
											data: {
												solarChargingTurnoffThreshold: parseFloat(value || '0'),
											},
										})
									}
									helperText={t('turnOffThresholdHelp')}
								/>
							</div>
						</div>
						<p className='text-sm text-text-grey-200 dark:text-text-grey-100'>{t('description')}</p>
						<p className='text-sm text-text-grey-200 dark:text-text-grey-100'>
							{t('description2')}
						</p>
					</div>
				</div>
			)}
		</>
	)
}

export default SolarChargingButton
